import type React from "react";
import Layout from "../../../components/site/Layout/Layout";
import Hero from "./components/Hero";
import UpcomingHackathon from "./components/UpcomingHackathon";
import PastHackathons from "./components/PastHackathons";
import Themes from "./components/Themes";
import Process from "./components/Process";
import Benefits from "./components/Benefits";
import FAQ from "./components/FAQ";
import CTA from "./components/CTA";

const HackathonPage: React.FC = () => {
	return (
		<Layout>
			<div className="w-full">
				<Hero />
				<UpcomingHackathon />
				<Themes />
				<Process />
				<Benefits />
				<PastHackathons />
				<FAQ />
				<CTA />
			</div>
		</Layout>
	);
};

export default HackathonPage;
